import React, { useState } from "react";
import { FaHourglassStart } from "react-icons/fa";
import { BiSolidFilePdf } from "react-icons/bi";
import { FaArrowLeftLong, FaSquareCheck } from "react-icons/fa6";
import { LuEye } from "react-icons/lu";
import { HiDownload } from "react-icons/hi";
import styles from "../../styles/__PatientInfo.module.scss";
import UserAvatar from "../../assets/images/patientAvatar.png";
import { BsFillChatTextFill } from "react-icons/bs";
import { LiaAngleDownSolid } from "react-icons/lia";
import { IoCheckboxOutline, IoCheckbox } from "react-icons/io5";
import { IoAddCircleOutline } from "react-icons/io5";
import { formatWholeAmount } from "../../utils/amountFormat";

export default function PatientInfo() {
  const reasons = {
    approved: [
      "Fully Approved",
      "Approved with 10% co-payment",
      "Approved with 15% co-payment",
      "Approved with 35% co-payment",
    ],
    rejected: [
      "Waiting period",
      "General exclusion",
      "Exceed the Maximum number of soaps",
      "Exceed the Financial Limitation",
      "Medical Case is not covered By policy",
      "Not Medically necessary",
    ],
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [totalClaimStatus, setTotalClaimStatus] = useState("approved");
  const [selected, setSelected] = useState(null);
  const [totalReasons, setTotalReasons] = useState(reasons.rejected);

  const [rows, setRows] = useState([
    { name: "Panadol", price: 54000, status: "approved" },
    { name: "Panadol", price: 54000, status: "rejected" },
    { name: "Ibuprofen", price: 54000, status: "approved" },
    { name: "Cetirizine", price: 12000, status: "rejected" },
  ]);

  const selectOption = (option) => {
    setSelected(option);
  };

  const toggleStatus = (i, status) => {
    const updated = [...rows];
    updated[i].status = status;
    setRows(updated);
  };

  const total = rows.reduce((t, r) => t + r.price, 0);

  const handleToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleTotalClaimStatus = () => {
    if (totalClaimStatus === "approved") {
      setTotalClaimStatus("rejected");
      setTotalReasons(reasons.rejected);
    } else {
      setTotalClaimStatus("approved");
      setTotalReasons(reasons.approved);
    }
  };

  return (
    <>
      <div className={styles["page-header"]}>
        <FaArrowLeftLong />
        <h2>#CLM3002</h2>
      </div>

      <div className={styles["dashboard-container"]}>
        <div className={styles["sidebar"]}>
          <div className={styles["info-block"]}>
            <div className={styles["info-header"]}>
              <h4>Patient Information</h4>
              <div className={styles["pendingStatus"]}>Pending</div>
            </div>

            <div className={styles["user-section"]}>
              <div className={styles["userInfo"]}>
                <img src={UserAvatar} className={styles["avatar"]} />
                <h3>John Doe</h3>
              </div>

              <div className={styles["msgIcon"]}>
                <BsFillChatTextFill />
              </div>
            </div>

            <ul>
              <li>
                <strong>Name:</strong> <span>John Doe</span>
              </li>
              <li>
                <strong>Date of Birth:</strong> <span>22/05/1998</span>
              </li>
              <li>
                <strong>Contact:</strong> <span>+958 542123648</span>
              </li>
              <li>
                <strong>Policy No:</strong> <span>120346qw21</span>
              </li>
              <li>
                <strong>Member ID:</strong> <span>1234567890</span>
              </li>
              <li>
                <strong>Insurance Provider</strong> <span>HealthPlus+</span>
              </li>
            </ul>
          </div>

          <div className={styles["policy-verfication"]}>
            <h3>
              <strong>Policy Verification:</strong>
            </h3>
            <div className={styles["verification-btns"]}>
              <button className={styles["solidRedBtn"]}>
                Reject and Close
              </button>
              <button className={styles["solidGreenBtn"]}>
                Verify and Continue
              </button>
            </div>
          </div>

          <div className={styles["info-block"]}>
            <h4>Consultation Details</h4>
            <ul>
              <li>
                <strong>Claim Type:</strong> <span>Medical Order</span>
              </li>
              <li>
                <strong>Claim Date:</strong> <span>22/05/1998</span>
              </li>
              <li>
                <strong>Amount:</strong> <span>IQD 120,000</span>
              </li>
            </ul>
          </div>

          <div className={styles["info-block"]}>
            <h4>Attached Documents</h4>

            {[
              "User National ID.pdf",
              "Insurance card.pdf",
              "Prescription.pdf",
            ].map((d, idx) => (
              <div key={idx} className={styles["doc-item"]}>
                <div className={styles["docInfo"]}>
                  <span className={styles["doc-icon"]}>
                    <BiSolidFilePdf />
                  </span>
                  <span>{d}</span>
                </div>

                <div className={styles["docIconWrapper"]}>
                  <LuEye className="text-primary" />
                  <HiDownload />
                </div>
              </div>
            ))}
          </div>

          <button className={styles["request-btn"]}>
            <IoAddCircleOutline size={20} />
            Request Document
          </button>
        </div>

        <div className={styles["mainContent"]}>
          <div className={styles["greenBorder-card"]}>
            <div className={styles["pharmacy-header"]}>
              <h3>Order Details</h3>
              <div className={styles["slaStatus"]}>
                <div className={styles["sla"]}>
                  <FaHourglassStart /> SLA Time Elapsed
                </div>
                <span>24:02:2023</span>
              </div>
            </div>

            <div className={styles["claim-card"]}>
              <div className={styles["claimTableWrapper"]}>
                <table>
                  <thead>
                    <tr>
                      <th>Medicine Name</th>
                      <th>Price</th>
                      <th>Claim Action</th>
                      <th>Reason for Approval/Rejection</th>
                    </tr>
                  </thead>

                  <tbody>
                    {rows.map((item, i) => (
                      <tr key={i}>
                        <td>{item.name}</td>
                        <td>IQD {formatWholeAmount(item.price)}</td>

                        <td>
                          <div className={styles["action-cell"]}>
                            <div className="">
                              <p>Approve</p>
                              {item.status === "approved" ? (
                                <IoCheckbox
                                  size={20}
                                  className={styles["btn-approve"]}
                                  onClick={() => toggleStatus(i, "approved")}
                                />
                              ) : (
                                <IoCheckboxOutline
                                  size={20}
                                  className={styles["btn-idle"]}
                                  onClick={() => toggleStatus(i, "approved")}
                                />
                              )}
                            </div>

                            <div className="">
                              <p>Reject</p>
                              {item.status === "rejected" ? (
                                <IoCheckbox
                                  size={20}
                                  className={styles["btn-reject"]}
                                  onClick={() => toggleStatus(i, "rejected")}
                                />
                              ) : (
                                <IoCheckboxOutline
                                  size={20}
                                  className={styles["btn-idle"]}
                                  onClick={() => toggleStatus(i, "approved")}
                                />
                              )}
                            </div>
                          </div>
                        </td>

                        <td>
                          <div className={styles["select-wrapper"]}>
                            <select>
                              <option disabled selected>
                                Select keyword
                              </option>
                              <option>Approved</option>
                              <option>Rejected</option>
                              <option>Partial - Co-pay</option>
                            </select>
                            <LiaAngleDownSolid
                              className={styles["selectIcon"]}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}

                    <tr className={styles["total-row"]}>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td>
                        <strong>IQD {formatWholeAmount(total)}</strong>
                      </td>
                      <td>
                        <div className={styles["action-cell"]}>
                          <div className="">
                            <p>Approve</p>
                            {totalClaimStatus === "approved" ? (
                              <IoCheckbox
                                size={20}
                                className={styles["btn-approve"]}
                                onClick={() => handleTotalClaimStatus()}
                              />
                            ) : (
                              <IoCheckboxOutline
                                size={20}
                                className={styles["btn-idle"]}
                                onClick={() => handleTotalClaimStatus()}
                              />
                            )}
                          </div>

                          <div className="">
                            <p>Reject</p>
                            {totalClaimStatus === "rejected" ? (
                              <IoCheckbox
                                size={20}
                                className={styles["btn-reject"]}
                                onClick={() => handleTotalClaimStatus()}
                              />
                            ) : (
                              <IoCheckboxOutline
                                size={20}
                                className={styles["btn-idle"]}
                                onClick={() => handleTotalClaimStatus()}
                              />
                            )}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div className={styles["dd-wrapper"]}>
                          <div
                            className={styles["dd-default"]}
                            onClick={() => handleToggle()}
                          >
                            <p>Approved with 35% co-payment</p>
                            <LiaAngleDownSolid className={styles["ddIcon"]} />
                          </div>
                          {dropdownOpen && (
                            <div className={styles["options-list"]}>
                              <h4>Reason</h4>
                              {totalReasons.map((item, i) => (
                                <div
                                  key={i}
                                  className={`${styles.item} ${
                                    selected === item ? styles.active : ""
                                  }`}
                                  onClick={() => selectOption(item)}
                                >
                                  <span className={styles.label}>{item}</span>

                                  <span
                                    className={`${styles.radio} ${
                                      selected === item
                                        ? styles.radioActive
                                        : ""
                                    }`}
                                  >
                                    <span className={styles.innerCircle}></span>
                                  </span>
                                </div>
                              ))}
                              {totalClaimStatus === "approved" && (
                                <div className={styles["coPayInfo"]}>
                                  <label>Custom Co-payment</label>
                                  <input type="text" placeholder="XX%" />
                                </div>
                              )}
                              <button
                                className={`${styles["solidGreenBtn"]} ${styles["ddConfirmBtn"]}`}
                              >
                                Confirm
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <button className={styles["outlineGreenBtn"]}>Calculate</button>
            </div>
          </div>

          <div className={`${styles["invoice-card"]} ${styles["info-block"]}`}>
            <h3>Invoice Breakdown</h3>

            <ul>
              <li>
                <strong>Total Amount:</strong> <span>IQD 120,000</span>
              </li>
              <li>
                <strong>Total Claimed:</strong> <span>IQD 120,000</span>
              </li>
              <li>
                <strong>Approved Amount:</strong> <span>IQD 108,000</span>
              </li>
              <li>
                <strong>Patient Share:</strong> <span>IQD 12,000</span>
              </li>
            </ul>

            <button className={styles["solidGreenBtn"]}>Update Invoice</button>
          </div>
        </div>
      </div>
    </>
  );
}
